
var id = "link";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"link\">\n<path d=\"M8.74681 5.45723L5.70014 2.41057C4.81304 1.52346 3.35521 1.543 2.44397 2.45422C1.53274 3.36543 1.5132 4.8233 2.40032 5.7104L5.04541 8.3555\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M10.968 7.66797L13.6131 10.3131C14.5002 11.2002 14.4807 12.658 13.5695 13.5693C12.6582 14.4805 11.2004 14.5 10.3133 13.6129L7.2666 10.5662\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M8.70312 8.71323C9.61436 7.802 9.63389 6.34416 8.74679 5.45703\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M7.26673 7.26562C6.3555 8.17686 6.33596 9.63469 7.22306 10.5218\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
